import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { setupBreedingPath } from "./setupRoutes";
import { SetupLayout } from "./SetupLayout";
import { SETUP_STEPS } from "./SetupStepBar";

// Clé passée en prop à SetupLayout, invisible du parser sans ce marqueur.
// i18n.t("setup-welcome-title")
export const SetupWelcomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SetupLayout titleKey="setup-welcome-title">
      <p className="text-default-text">{t("setup-welcome-intro")}</p>

      <ol className="mt-6 flex flex-col gap-3">
        {SETUP_STEPS.map(({ step, labelKey }) => (
          <li
            key={step}
            className="flex items-center gap-3 bg-grey-light/50 rounded-lg px-4 py-3 text-default-text"
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-tertiary text-secondary-text font-oxaniumMedium text-sm">
              {step}
            </span>
            <span className="font-oxaniumMedium">{t(labelKey)}</span>
          </li>
        ))}
      </ol>

      <p className="mt-4 flex items-start gap-2 text-sm text-grey-readable">
        <FontAwesomeIcon icon="info-circle" className="mt-1" />
        <span>{t("setup-welcome-hint")}</span>
      </p>

      <div className="mt-8">
        <Button size="full" onClick={() => navigate(setupBreedingPath())}>
          {t("setup-welcome-start")}
        </Button>
      </div>
    </SetupLayout>
  );
};
